import { useState } from 'react';

import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { Modal } from 'features/modals';
import { useStore } from 'models/Provider';

export default function RemoveConfirmModal({ closeModal, data, confirm }) {
  const [submitting, setSubmitting] = useState(false);
  const { t } = useStore();
  async function submit() {
    setSubmitting(true);
    const success = await confirm(data.id);
    setSubmitting(false);
    if (success) {
      closeModal();
    }
  }

  return (
    <Modal>
      <Modal.Header data-cy="modal-header" text={t('modals.removeconfirm.title')} />
      <Stack space={4}>
        <Text text={data.confirmText} />
        <Text color="red100" font="bold16" text={t('modals.removeconfirm.warning')} />
      </Stack>

      <Modal.Actions>
        <Button
          variant="secondary"
          onClick={!submitting ? closeModal : null}
          isDisabled={submitting}
          text={t('modals.removeconfirm.button.cancel')}
        />
        <Button
          data-cy="modal-confirm-button"
          variant="primary-red"
          onClick={!submitting ? submit : null}
          isDisabled={submitting}
          text={t('modals.removeconfirm.button.submit')}
        />
      </Modal.Actions>
    </Modal>
  );
}
